// Shared line/charge amount helper used by every billing strategy.
// move 0 = percent of `amount`, move 1 = fixed `value`, else 0.
// Kept in its own module (no deps) so strategies and TableHelper can both
// import it without a circular dependency.
export function discountLineFn(amount: number, move: number, value: number) {
    var money = 0;
    switch (move) {
        case 0:
            //percent
            money = amount * value / 100
            break;
        case 1:
            //amount
            money = value
            break;
        default:
            money = 0
    }
    return money || 0;
}

// Item-line discount. NOT interchangeable with discountLineFn above.
//
// A mode-1 (fixed baht) ITEM discount is always PER PIECE — the stored `value`
// is what one unit comes off by, and the ×quantity happens here, at bill-build
// time. That is legacy Food.Web behaviour (Scripts/class/model.line.js
// `discountCalculate`: `discount = value * quantity`) and it is what keeps
// void / split / move correct for free: those only change `quantity`, and the
// discount follows on the next recompute. Never store a pre-multiplied amount.
//
// Bill-level charges (service charge / card charge / whole-bill discount) have
// no quantity and keep using discountLineFn, where mode 1 is a flat amount.
export function discountItemLineFn(
    extendedPrice: number,
    quantity: number,
    move: number,
    value: number,
) {
    if (move === 1) {
        return (value || 0) * (quantity || 0)
    }
    return discountLineFn(extendedPrice, move, value)
}
